export type LandingGenreGroup = [string, string[]];

const EN_ITEMS: [string[], string[], string[]] = [
  ["Thriller", "Romance", "Fantasy", "Sci-Fi", "Literary", "Horror", "YA", "Crime", "Historical"],
  ["Self-Help", "Business", "Memoir", "Guides", "How-To"],
  ["Picture Books", "Middle Grade"],
];

const GENRE_CATEGORY_LABELS: Record<string, [string, string, string]> = {
  EN: ["Fiction", "Non-Fiction", "Children's"],
  DA: ["Fiktion", "Faglitteratur", "Børnebøger"],
  DE: ["Fiktion", "Sachbuch", "Kinderbücher"],
  FR: ["Fiction", "Non-fiction", "Littérature jeunesse"],
  IT: ["Narrativa", "Saggistica", "Libri per bambini"],
  ES: ["Ficción", "No ficción", "Infantil"],
  PT: ["Ficção", "Não ficção", "Infantil"],
  NL: ["Fictie", "Non-fictie", "Kinderboeken"],
  SE: ["Skönlitteratur", "Facklitteratur", "Barnböcker"],
  PL: ["Beletrystyka", "Literatura faktu", "Dla dzieci"],
};

const GENRE_ITEMS_BY_LANG: Partial<Record<string, [string[], string[], string[]]>> = {
  DA: [
    ["Thriller", "Romantik", "Fantasy", "Sci-fi", "Litterær", "Gyser", "YA", "Krimi", "Historisk"],
    ["Selvhjælp", "Business", "Memoir", "Guides", "How-to"],
    ["Billedbøger", "Mellemtrin"],
  ],
  IT: [
    ["Thriller", "Romanzo rosa", "Fantasy", "Fantascienza", "Letteratura", "Horror", "YA", "Giallo", "Storico"],
    ["Sviluppo personale", "Business", "Memorie", "Guide", "Tutorial"],
    ["Libri illustrati", "11-13 anni"],
  ],
  NL: [
    ["Thriller", "Romantiek", "Fantasy", "Sci-Fi", "Literatuur", "Horror", "YA", "Misdaad", "Historisch"],
    ["Zelfhulp", "Business", "Memoires", "Gidsen", "How-to"],
    ["Prentenboeken", "8-12 jaar"],
  ],
};

export function buildLandingGenreGroups(lang: string | null | undefined): LandingGenreGroup[] {
  const code = String(lang || "EN").toUpperCase();
  const labels = GENRE_CATEGORY_LABELS[code] || GENRE_CATEGORY_LABELS.EN;
  const items = GENRE_ITEMS_BY_LANG[code] || EN_ITEMS;
  return [
    [labels[0], items[0]],
    [labels[1], items[1]],
    [labels[2], items[2]],
  ];
}
